// plugins/msw.client.ts

export default defineNuxtPlugin(async nuxt => {
	if (
		process.env.NODE_ENV !== 'development' &&
		!nuxt.globalName.includes('nuxt-app-components')
	) {
		return {};
	}

	// const { worker } = await import('~~/mocks/browser')

	// // `worker.start()` returns a Promise that resolves
	// // once the Service Worker is up and ready to intercept requests.
	// return worker.start({
	//   onUnhandledRequest: 'bypass',
	// })
});
